const PLANS = [
  {
    name: "HOA Refresh",
    price: "$6,000",
    unit: "one-time",
    tagline: "HOA communities · 200 residents or fewer",
    badge: null,
    features: [
      "Website refresh and content update",
      "Statutory compliance review",
      "ADA / WCAG 2.2 scan",
      "Board-ready summary PDF",
      "60-min findings call",
    ],
    cta: "Get started",
    highlight: false,
    callUs: false,
  },
  {
    name: "55+ New Build",
    price: "$15K – $20K",
    unit: "one-time · from",
    tagline: "55+ / HOPA communities · 200+ residents",
    badge: "Most popular",
    features: [
      "Full compliant website new build",
      "HOPA 55+ toolkit included",
      "Owner-only records vault",
      "PDF remediation (up to 200)",
      "Board meeting portal",
      "Multilingual toggle (EN/ES/PT)",
    ],
    cta: "Get started",
    highlight: true,
    callUs: false,
  },
  {
    name: "HOA New Build",
    price: "$20K – $25K",
    unit: "one-time · from",
    tagline: "HOA communities · 500+ residents",
    badge: null,
    features: [
      "Full compliant website new build",
      "Statute 720/718/719 compliance",
      "Owner-only records vault",
      "PDF remediation (up to 200)",
      "Board meeting and violation portals",
      "Multilingual toggle (EN/ES/PT)",
    ],
    cta: "Get started",
    highlight: false,
    callUs: false,
  },
  {
    name: "Non-HOA Build",
    price: "$15,000",
    unit: "one-time · from",
    tagline: "Non-HOA communities · 250+ residents",
    badge: null,
    features: [
      "Full compliant website new build",
      "12–24 month maintenance schedule",
      "ADA / WCAG 2.2 remediation",
      "Owner-only records vault",
      "Board meeting portal",
      "Priority remediation queue",
    ],
    cta: "Get started",
    highlight: false,
    callUs: false,
  },
  {
    name: "Large Community",
    price: "Custom",
    unit: "call to schedule",
    tagline: "Communities of 500+ residents",
    badge: null,
    features: [
      "Tailored scope and pricing",
      "Dedicated team member assigned",
      "Full compliance stack",
      "Enterprise SLA available",
      "Multi-phase delivery options",
    ],
    cta: "Get started",
    highlight: false,
    callUs: false,
  },
];

export default function Pricing() {
  return (
    <section id="pricing" className="py-24 md:py-32 bg-background-100 border-y border-background-200">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-14">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-primary-700 font-semibold">
            <i className="ri-price-tag-3-line" />
            Straightforward pricing
          </span>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl font-semibold text-foreground-950 leading-[1.05]">
            Board-friendly quotes. No open-ended retainers.
          </h2>
          <p className="mt-6 text-foreground-700 text-lg leading-relaxed">
            Every engagement is priced up front, approved by the board, and delivered against a documented
            scope. Larger communities receive a custom proposal after the discovery call.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {PLANS.map((p) => (
            <div
              key={p.name}
              className={`relative rounded-lg p-8 flex flex-col border transition-transform hover:-translate-y-1 ${
                p.highlight
                  ? "bg-primary-500 border-primary-500 text-background-50"
                  : "bg-background-50 border-background-200 text-foreground-950"
              }`}
            >
              {p.badge && (
                <span className="absolute -top-3 left-8 bg-accent-500 text-background-50 text-xs font-semibold px-3 py-1 rounded-full">
                  {p.badge}
                </span>
              )}
              <div>
                <h3
                  className={`font-heading text-2xl font-semibold ${
                    p.highlight ? "text-background-50" : "text-foreground-950"
                  }`}
                >
                  {p.name}
                </h3>
                <p
                  className={`mt-1 text-sm ${
                    p.highlight ? "text-background-100" : "text-foreground-600"
                  }`}
                >
                  {p.tagline}
                </p>
              </div>
              <div className="mt-6 flex items-baseline gap-2">
                <span
                  className={`font-heading text-3xl font-semibold tracking-tight whitespace-nowrap ${
                    p.highlight ? "text-background-50" : "text-foreground-950"
                  }`}
                >
                  {p.price}
                </span>
                <span
                  className={`text-sm ${
                    p.highlight ? "text-background-100" : "text-foreground-500"
                  }`}
                >
                  {p.unit}
                </span>
              </div>
              <ul
                className={`mt-8 space-y-3 flex-1 pt-6 border-t ${
                  p.highlight ? "border-background-50/20" : "border-background-200"
                }`}
              >
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm">
                    <i
                      className={`ri-check-double-line mt-0.5 ${
                        p.highlight ? "text-accent-200" : "text-primary-600"
                      }`}
                    />
                    <span className={p.highlight ? "text-background-50" : "text-foreground-800"}>
                      {f}
                    </span>
                  </li>
                ))}
              </ul>
              <a
                href={p.callUs ? "tel:+19544444747" : "#contact"}
                className={`mt-8 inline-flex items-center justify-center gap-2 font-semibold text-sm px-5 py-3.5 rounded-md cursor-pointer whitespace-nowrap transition-colors ${
                  p.highlight
                    ? "bg-background-50 text-primary-700 hover:bg-background-100"
                    : "bg-foreground-950 text-background-50 hover:bg-foreground-800"
                }`}
              >
                {p.cta}
                <i className={p.callUs ? "ri-phone-line" : "ri-arrow-right-line"} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}